import { render } from "./resources-carousel.vue?vue&type=template&id=5a126620"
import script from "./resources-carousel.vue?vue&type=script&lang=js"
export * from "./resources-carousel.vue?vue&type=script&lang=js"

import "./resources-carousel.vue?vue&type=style&index=0&id=5a126620&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__